<template>
	<card :header="false"  title="Pacient profile">
		<div class="sk-group">
			<div class="sk-group-l">
				<avatar class="sk-avatar-margin" :size="100" :src="patient.picture" :name="patient.name" />
				<span class="sk-value">{{ patient.name }}</span>
				<span class="sk-sub-value">{{ patient.profile.address }}</span>
			</div>
			<div class="sk-group-m">
				<div><span class="sk-value">{{ yearsOld }}</span><span class="sk-title">Years old</span></div>
				<div><span class="sk-value">{{ gender }}</span><span class="sk-title">Gender</span></div>
			</div>
			<div class="sk-group-m">
				<div><span class="sk-value">{{ height }} m</span><span class="sk-title">Height</span></div>
				<div><span class="sk-value">{{ weight }} kg</span><span class="sk-title">{{ $t('Weight') }}</span></div>
			</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchProfile" :args="{ watch_id: patientId }" :title="$t('Go to profile')" />
			<card-option-item-button @click="onOpenConfig_ClickHandler" :title="$t('Configurations')" />
		</template>
		<watch-options ref="watchOptions" :user_uid="userUid" :watch_id="patientId" />
	</card>
</template>

<script>
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import CardOptionItemButton from '@/modules/common/CardOptionItemButton'
import Card from '@/modules/common/Card'
import Avatar from '@/modules/ui/Avatar'
import WatchOptions from '@/components/watch/options/WatchOptions'
import moment from 'moment'
export default {
	name: 'card-pacient-profile',
	props: {
		patient: {
			type: Object,
			default: () => ({
				profile: {}
			})
		}
	},
	components: {
		Card,
		Avatar,
		CardOptionItemLink,
		CardOptionItemButton,
		WatchOptions
	},
	computed: {
		patientId() {
			return parseInt(this.patient.id)
		},
		userUid() {
			return this.$route.params.user_uid
		},
		profile() {
			return this.patient.profile
		},
		yearsOld() {
			return moment().diff(this.profile.birthday, 'years', false);
		},
		gender() {
			return this.profile.gender === 'M' ? this.$t('Male') : this.$t('Female')
		},
		weight() {
			return (this.profile.weight / 1000).toFixed(2)
		},
		height() {
			return (this.profile.height / 100).toFixed(2)
		},
	},
	methods: {
		onOpenConfig_ClickHandler() {
			this.$refs.watchOptions.openModal()
		}
	}
}
</script>
<style scoped>
.sk-avatar-margin {
	margin: 0 0 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/modules/pacient/CardPacientProfile.vue